var MuiLink = {
  styleOverrides: {
    root: {
      '&.MuiLink-button': {
        fontWeight: 500
      }
    }
  }
};
export default {
  MuiLink: MuiLink
};